export default __webpack_public_path__ + "47fffb13229f072068d91e31870143d8.svg";